import React, { useState } from "react";
import { motion } from "framer-motion";
import Popup from "../components/Popup";
import WebinarFormPopup from "../components/WebinarFormPopup";
import { FaVideo, FaTools, FaInfinity, FaBriefcase } from "react-icons/fa";
import AboutBanner from "../components/AboutBanner";
import AboutWelcome from "../components/AboutWelcome";
import RealStoriesSection from "../components/RealStoriesSection";
import CoursesHelpSection from "../components/CoursesHelpSection";
import WhyWeStandOut from "../components/WhyWeStandOut";
import OurStory from "../components/OurStory";
import AboutClassesSection from "../components/AboutClassesSection";
import AboutFreeTrialSection from "../components/AboutFreeTrialSection";
import StudyInAmerica from "../components/StudyInAmerica";

// Animation variants
const sectionVariants = {
  hidden: { opacity: 0, y: 50 },
  visible: (i) => ({
    opacity: 1,
    y: 0,
    transition: { delay: i * 0.2, duration: 0.6, ease: "easeOut" }
  }),
};

function AboutNewzeal() {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [popupContent, setPopupContent] = useState(null);

  const openPopup = (content) => {
    setPopupContent(content);
    setIsPopupOpen(true);
  };

  const closePopup = () => {
    setIsPopupOpen(false);
    setPopupContent(null);
  };

  const courseData = {
    highlights: [
      { icon: <FaVideo />, text: "350+ Live sessions" },
      { icon: <FaTools />, text: "15+ Industry Projects" },
      { icon: <FaInfinity />, text: "Lifetime accessibility" },
      { icon: <FaBriefcase />, text: "Live project experience" },
    ],
    title: "Basic Level: Spoken English Course Content",
    description:
      "This course is designed for individuals who can read and write English but lack confidence and fluency in speaking. The focus is on practical communication skills and real-world application.",
    // price: "120,000",
    emi: "5,900",
    applyLink: "#apply",

    batchDate: { day: "19", month: "AUG", batch: "Morning" },
    batchName: "Next Advanced Level: Spoken English",
    batchDays: "Sat - Sun",
    batchTime: "09:00 am - 12:00 pm",
    batchSeat: "Available",
    batchVenue: "Virtual Hall",
    enrollLink: "#enroll",
  };

  return (
    <>
      {/* Each section wrapped in motion.div with staggered animation */}
      <motion.div
        variants={sectionVariants}
        initial="hidden"
        animate="visible"
        custom={0}
      >
        <AboutBanner />
      </motion.div>

      <motion.div
        variants={sectionVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        custom={1}
      >
        <AboutWelcome />
      </motion.div>

      <motion.div
        variants={sectionVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        custom={2}
      >
        <OurStory />
      </motion.div>

      <motion.div
        variants={sectionVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        custom={3}
      >
        <WhyWeStandOut />
      </motion.div>

      <motion.div
        variants={sectionVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        custom={4}
      >
        <CoursesHelpSection />
      </motion.div>

      {/* <motion.div
        variants={sectionVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        custom={5}
      >
        <RealStoriesSection />
      </motion.div> */}

      {/* <motion.div
        variants={sectionVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        custom={6}
      >
        <AboutClassesSection />
      </motion.div> */}

      <motion.div
        variants={sectionVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        custom={7}
      >
        <AboutFreeTrialSection />
      </motion.div>

      <motion.div
        variants={sectionVariants}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true }}
        custom={8}
      >
        <StudyInAmerica />
      </motion.div>

      <Popup isOpen={isPopupOpen} onClose={closePopup}>
        <WebinarFormPopup onClose={closePopup} />
      </Popup>
    </>
  );
}

export default AboutNewzeal;
